import PhotoSwiper from '../src/PhotoSwiper';
export default PhotoSwiper;
